import { BbsBbsControllerApi } from "@/http/apis";
const bbsApi = new BbsBbsControllerApi();
export const bbsService = {
  /**
   * 获取公告分类树
   */
  async getCategoryTree() {
    const res = await bbsApi.annBbsCurrentTreeGet({});
    return res?.data || [];
  },

  /**
   * 获取公告内容列表
   */
  async getContentList(params: {
    currentPage?: number;
    pageSize?: number;
    keyword?: string;
    categoryId?: number;
  }) {
    const res = await bbsApi.annBbsCurrentContentListGet({
      currentPage: params.currentPage ?? 1,
      pageSize: params.pageSize ?? 20,
      keyword: params.keyword,
      categoryId: params.categoryId,
    });
    return res?.data || {};
  },

  /**
   * 指定多个分类编号，获取分类下内容信息列表
   */
  async getContentListByCategoryIds(params: {
    categoryIds: number[];
    currentPage?: number;
    pageSize?: number;
  }) {
    const res = await bbsApi.annBbsCurrentContentListByCategoryIdsGet({
      categoryIds: params.categoryIds,
      currentPage: params.currentPage ?? 1,
      pageSize: params.pageSize ?? 20,
    });
    return res?.data || [];
  },

  /**
   * 获取公告内容详情
   */
  async getContentDetail(id: number) {
    const res = await bbsApi.annBbsCurrentContentIdGet({ id });
    return res?.data || null;
  },
};
